import React from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import Constant from "../Constant";

export default function ReceptionCarType(props) {
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies();
  return (
    <ReceptionCarTypeComp
      {...props}
      navigate={navigate}
      cookies={cookies}
      setCookie={setCookie}
    />
  );
}

class ReceptionCarTypeComp extends React.Component {
  constructor(props) {
    super(props);
    this.cookies = props.cookies;
    this.setCookie = props.setCookie;
    this.state = {
      car_type: this.cookies.car_type,
    };
  }

  nextOnClick = async (event) => {
    if (!this.state.car_type) {
      alert("予約の種類を選択してください。");
      return false;
    }
    this.setCookie("car_type", this.state.car_type);
    if (this.state.car_type == Constant.CAR_TYPE_1) {
      this.props.navigate("/reception_inspection_type");
    } else {
      this.setCookie("inspection_type", 0);
      this.props.navigate("/reception_date");
    }
  };

  render() {
    console.log("render()");
    console.log(this.state.car_type);
    return (
      <div class="content-wrapper">
        {/* Content Wrapper. Contains page content */}
        {/* Content Header (Page header) */}
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h3 class="mb-0">予約受付</h3>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>

        {/* Main content */}
        <section class="content">
          <div class="container-fluid">
            <div class="card card-default">
              <div class="card-body">
                <div class="row pb-4">
                  <div class="col-12">
                    <label>予約の種類を選択してください。</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <div
                        class="btn-group-toggle"
                        data-toggle="buttons"
                        value={this.state.car_type}
                        onChange={(event) => {
                          this.setState({
                            car_type: event.target.value,
                          });
                        }}
                      >
                        <label
                          id="car_type_1"
                          className={
                            this.state.car_type == Constant.CAR_TYPE_1
                              ? "btn btn-block btn-outline-primary focus active"
                              : "btn btn-block btn-outline-primary"
                          }
                        >
                          <input
                            type="radio"
                            name="car_type"
                            value="1"
                            autocomplete="off"
                            checked={
                              this.state.car_type == Constant.CAR_TYPE_1
                                ? true
                                : false
                            }
                          />
                          陸運事務所
                        </label>
                        <br />
                        <label
                          id="car_type_2"
                          className={
                            this.state.car_type == Constant.CAR_TYPE_2
                              ? "btn btn-block btn-outline-primary focus active"
                              : "btn btn-block btn-outline-primary"
                          }
                        >
                          <input
                            type="radio"
                            name="car_type"
                            value="2"
                            autocomplete="off"
                            checked={
                              this.state.car_type == Constant.CAR_TYPE_2
                                ? true
                                : false
                            }
                          />
                          軽自動車
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer pt-2 pb-2">
                <div class="row">
                  <div class="col-12 text-center">
                    <button
                      type="button"
                      class="btn btn-primary"
                      onClick={this.nextOnClick}
                    >
                      次へ
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
        {/* /.content-wrapper */}
      </div>
    );
  }
}
